// Mock data for Rohan Pudasaini's Portfolio

export const personalInfo = {
  name: "Rohan Pudasaini",
  title: "AI/ML Backend Engineer & Network Security Enthusiast",
  location: "Kathmandu, Nepal",
  email: "hello@therohan.dev",
  phone: "+977 9861496352",
  website: "rohanpudasaini.com.np",
  github: "https://github.com/Rohanpudasaini",
  linkedin: "https://linkedin.com/in/pudasaini-rohan",
  heroImage: "/hero.jpg",
  summary: "AI/ML Backend Engineer with 3+ years of professional experience specializing in Python, FastAPI, and MLOps principles. Proven ability to integrate complex AI/ML models (RASA, Whisper) and external agent APIs via high-efficiency protocols like gRPC and WebSockets. Adept at designing and deploying scalable, containerized backend services using PostgreSQL and Docker for production environments."
};

export const experiences = [
  {
    id: 1,
    title: "ML Engineer",
    company: "Vanilla Transtechnor",
    location: "Kathmandu",
    period: "July 2025 - November 2025",
    responsibilities: [
      "Led the ML team, overseeing the development and deployment of machine learning models.",
      "Engineered and configured the infrastructure for model deployment, ensuring scalability and reliability.",
      "Developed a chatbot application, utilizing RASA for intent recognition and Whisper for accurate audio transcription from user inputs.",
      "Used the Factory pattern to dynamically select and integrate a fallback LLM API (Amazon Bedrock/Other LLMs) when RASA classification confidence was below threshold.",
      "Utilized WS to ensure a stateful connection between the client and server for real-time communication.",
      "Implemented gRPC to separate and ensure efficient communication between various services."
    ]
  },
  {
    id: 2,
    title: "Python Developer",
    company: "Vanilla Transtechnor",
    location: "Kathmandu",
    period: "May 2024 - July 2025",
    responsibilities: [
      "Designed and developed RESTful APIs using Python, FastAPI, and SQLAlchemy.",
      "Worked with relational database like PostgreSQL to build scalable backend solutions.",
      "Containerized applications using Docker for efficient deployment.",
      "Initiated and led Python knowledge transfer sessions within the team to enhance collaboration and skill development.",
      "Conducted on-call discussions with clients to gather accurate requirements and ensure the delivery of tailored solutions."
    ]
  },
  {
    id: 3,
    title: "Python Intern",
    company: "Vanilla Transtechnor",
    location: "Kathmandu",
    period: "January 2024 - May 2024",
    responsibilities: [
      "Worked closely with a senior developer to gain hands-on experience in building RESTful APIs using FastAPI, PostgreSQL, SQLAlchemy, and Alembic.",
      "Contributed to the development of a Library Management System and a Device Management System, implementing Role-Based Access Control (RBAC) and authorization mechanisms to ensure secure and scalable solutions.",
      "This experience strengthened my understanding of backend development, database management, and API design principles."
    ]
  },
  {
    id: 4,
    title: "Freelance Python Developer",
    company: "People Per Hour",
    location: "Remote",
    period: "May 2022 - Present",
    responsibilities: [
      "Developed bespoke GUI and command-line applications using tKinter and PySimpleGUI.",
      "Automated web tasks such as bulk login/registration and data scraping using Selenium, BS4, and Requests.",
      "Performed advanced mail merges and template-based document editing using docx2pdf.",
      "Utilized Tesseract and Pytesseract for OCR tasks and implemented bulk messaging for Instagram users.",
      "Integrated APIs to fetch and analyze stock data for FTSE 250 companies based on user requirements.",
      "Extracted and plotted geographical coordinates from CSV data using Folium and OpenStreetMap, saving outputs as offline HTML.",
      "Assisted in managing and maintaining client networks, along with handling various day-to-day activities to meet client needs."
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "AI Chatbot Backend",
    description: "High-performance chatbot backend utilizing WebSockets for secure, real-time user interaction with JWT authentication. Multi-layered AI agent integration routing requests through RASA for intent recognition, with Amazon Bedrock/LLM fallback.",
    technologies: ["RASA", "WebSocket", "JWT", "Amazon Bedrock", "LLM", "CI/CD"],
    github: null,
    demo: null
  },
  {
    id: 2,
    title: "Gemini Coding Agent",
    description: "Autonomous coding agent utilizing Google Gen AI SDK for agentic tool calling. Implemented custom tools for file operations (read, write, edit), enabling natural language command interpretation and direct codebase modification.",
    technologies: ["Google Gen AI SDK", "Python", "AI Agents", "Tool Calling"],
    github: "https://github.com/Rohanpudasaini/gemini-agent",
    demo: null
  },
  {
    id: 3,
    title: "Smart Pantry Capstone",
    description: "Intelligent dietary assistant analyzing pantry inventory and meal history to generate personalized suggestions. Leveraged agentic tool calling to interface with external APIs, integrating Spoonacular and USDA database.",
    technologies: ["AI Agents", "Spoonacular API", "USDA API", "Python", "FastAPI"],
    github: "https://github.com/Rohanpudasaini/Smart-Pantry",
    demo: null
  },
  {
    id: 4,
    title: "Machine Learning Classification Model",
    description: "ML classification model for large-scale data with generalized blueprint for model selection, feature engineering, and hyperparameter tuning. Integrated with FastAPI backend and frontend interface for end-to-end interaction.",
    technologies: ["Machine Learning", "FastAPI", "Python", "scikit-learn", "React"],
    github: null,
    demo: null
  },
  {
    id: 5,
    title: "Merchantrade Money App API",
    description: "Contributed to API development by implementing RESTful endpoints, writing integration tests, and optimizing database queries for improved performance and scalability.",
    technologies: ["FastAPI", "PostgreSQL", "REST API", "Testing"],
    github: null,
    demo: "https://play.google.com/store/apps/details?id=com.mtradeasia.mmp"
  },
  {
    id: 6,
    title: "Device Management System",
    description: "Robust device management system API crafted using FastAPI for handling endpoints, SQLAlchemy as the ORM, and PostgreSQL for the backend database.",
    technologies: ["FastAPI", "SQLAlchemy", "PostgreSQL", "REST API"],
    github: "https://github.com/Rohanpudasaini/DeviceManagementSystem",
    demo: null
  },
  {
    id: 7,
    title: "Library Management System",
    description: "Simple library management system API created using FastAPI for endpoints, SQLAlchemy for ORM and PostgreSQL for the backend database.",
    technologies: ["FastAPI", "SQLAlchemy", "PostgreSQL", "REST API"],
    github: "https://github.com/Rohanpudasaini/library_management_system_fastAPI",
    demo: null
  },
  {
    id: 8,
    title: "FastAPI App with RBAC",
    description: "Simple Fast API application with role-based access control implementing secure authentication and authorization mechanisms.",
    technologies: ["FastAPI", "RBAC", "JWT", "PostgreSQL"],
    github: "https://github.com/Rohanpudasaini/role_base_access_control_fastAPI",
    demo: null
  },
  {
    id: 9,
    title: "E-Commerce Website",
    description: "Django website with recommendation system created for final year project, featuring product catalog, user authentication, and personalized recommendations.",
    technologies: ["Django", "Python", "Machine Learning", "PostgreSQL"],
    github: "https://github.com/Rohanpudasaini/fyp_django",
    demo: null
  }
];

export const skills = {
  languages: ["Python", "JavaScript", "SQL"],
  frameworks: ["FastAPI", "Django", "React", "SQLAlchemy"],
  mlAi: ["Machine Learning", "RASA", "Whisper", "AI Agents", "LLM Integration"],
  databases: ["PostgreSQL", "MongoDB"],
  devOps: ["Docker", "Git/GitHub", "Linux", "CI/CD"],
  protocols: ["WebSocket", "gRPC", "REST API", "JWT"],
  security: ["Penetration Testing", "Network Security", "Metasploit", "OSINT", "Web Exploitation"]
};

export const certifications = [
  {
    id: 1,
    name: "Google x Kaggle 5-Day AI Agents Intensive Course",
    issuer: "Google x Kaggle",
    year: "2025",
    link: "https://www.kaggle.com/certification/badges/pudasainirohan/105"
  },
  {
    id: 2,
    name: "CS50P",
    issuer: "Harvard University",
    year: "2025",
    link: "https://raw.githubusercontent.com/Rohanpudasaini/Rohanpudasaini/refs/heads/main/CS50P.png"
  },
  {
    id: 3,
    name: "Machine Learning Specialization",
    issuer: "Coursera",
    year: "2025",
    link: "https://coursera.org/share/f119ff73a1dbd28477bbe4c5de80a68e"
  },
  {
    id: 4,
    name: "Supervised Machine Learning: Regression and Classification",
    issuer: "Coursera",
    year: "2025",
    link: "https://coursera.org/share/ac425df8fffc741b9252d54a44c0cebd"
  },
  {
    id: 5,
    name: "Advanced Learning Algorithms",
    issuer: "Coursera",
    year: "2025",
    link: "https://coursera.org/share/d7f854b02923347b98bf4b67d542ee99"
  },
  {
    id: 6,
    name: "Unsupervised Learning, Recommenders, Reinforcement Learning",
    issuer: "Coursera",
    year: "2025",
    link: "https://coursera.org/share/135acc16c961b3686c4377ce316c58a8"
  }
];

export const cyberAchievements = {
  tryhackme: {
    roomsCompleted: "45+",
    badges: "10+",
    notableRooms: ["Mr. Robot", "Blue", "OhSINT"],
    skills: ["Metasploit", "Linux", "Web Exploitation", "Hash Cracking", "OSINT"]
  },
  expertise: [
    "Penetration Testing",
    "Network Security",
    "Security Assessment",
    "Vulnerability Analysis"
  ]
};

export const education = {
  degree: "Bachelor's in Computer Science and Information Technology",
  institution: "St-Lawrence College",
  location: "Kathmandu",
  period: "May 2019 - May 2024"
};